/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_Emaillabel1Inputs */

const ja_playdata_home_newsletter_emaillabel1 = /** @type {(inputs: Playdata_Home_Newsletter_Emaillabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Address`)
};

const en_playdata_home_newsletter_emaillabel1 = /** @type {(inputs: Playdata_Home_Newsletter_Emaillabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Address`)
};

/**
* | output |
* | --- |
* | "Email Address" |
*
* @param {Playdata_Home_Newsletter_Emaillabel1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_home_newsletter_emaillabel1 = /** @type {((inputs?: Playdata_Home_Newsletter_Emaillabel1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_Emaillabel1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_emaillabel1(inputs)
	return en_playdata_home_newsletter_emaillabel1(inputs)
});
export { playdata_home_newsletter_emaillabel1 as "playdata_home_newsletter_emailLabel" }